import React from 'react';
import PrimaryHeading from "../../components/PrimaryHeading/PrimaryHeading";
import HeadingGradient from "../../components/HeadingGradient/HeadingGradient";
import Tile from "../../components/Tile/Tile";
import FoodSource from "../../components/FoodSource/FoodSource";
import ChartTable from "../../components/ChartTable/ChartTable";
import ComplexChart from "../../components/ComplexChart/ComplexChart";
import TileLegend from "../../components/TileLegend/TileLegend";
import { getHalves } from "../../core/helpers";
import SecondaryHeading from "../../components/SecondaryHeading/SecondaryHeading";
import ObtainedFood from "../../components/ObtainedFood/ObtainedFood";

function SectionWhere({ foodSourceData, decisionPointData, consumptionPointData, segmentShareData, manageLinkAccordingToPermissions, obtainedData }) {
    return (
        <div className="details-chart">
            <PrimaryHeading>
                <HeadingGradient>Where</HeadingGradient>
                <span>insights around where consumers sourced their food,<br/> how they got it, and where they consumed it</span>
            </PrimaryHeading>
            <Tile>
                <FoodSource data={foodSourceData}/>
            </Tile>
            <Tile>
                <div className="row">
                    <div className="col-50">
                        <div className="details-chart__table">
                            <ChartTable
                                title="Decision Point"
                                subtitle="where they were when they made their decision to eat"
                                data={decisionPointData}
                            />
                        </div>
                    </div>
                    <div className="col-50">
                        <div className="details-chart__table">
                            <ChartTable
                                title="Consumption Point"
                                subtitle="where the food was actually consumed"
                                data={consumptionPointData}
                            />
                        </div>
                    </div>
                </div>
            </Tile>
            <Tile>
                <ComplexChart
                    title={(
                        <>
                            Segment Share{/* <TileLegend />*/}
                        </>
                    )}
                    subTitle="% of events sourcing from that type of venue"
                    note={(
                        <>
                            Insights around where consumers sourced their food,
                            <br/> how they got it, and where they consumed it
                        </>
                    )}
                    columnsConfig={[[1], [2], [3]]}
                    categories={[
                        {
                            ...segmentShareData[0],
                            items: getHalves(segmentShareData[0].items)[0].map(manageLinkAccordingToPermissions),
                            id: 1,
                        },
                        {
                            ...segmentShareData[0],
                            name: '',
                            items: getHalves(segmentShareData[0].items)[1].map(manageLinkAccordingToPermissions),
                            id: 2,
                        },
                        {
                            ...segmentShareData[1],
                            items: segmentShareData[1].items.map(manageLinkAccordingToPermissions),
                            id: 3,
                        },
                    ]}
                />
            </Tile>
            <Tile>
                <SecondaryHeading isCentered>
                    How the food Was Obtained
                </SecondaryHeading>
                <ObtainedFood data={obtainedData}/>
            </Tile>
        </div>
    );
}

export default SectionWhere;